/** 差し込み文字を、届いたときのイメージが伝わる日本語へ置き換える。 */
export function previewNameInsertion(content: string): string {
  return content.replace(/\{\{name\}\}/g, '（友だちの名前）');
}
